export const findCurrentImage = (src, imageList) => {
    const currentFile = imageList.filter((image) => image.previewUrl === src)
    return {file: currentFile[0].file, previewUrl: currentFile[0].previewUrl}
}